// controls.js


function easeOutQuad(x) {
  return 1 - (1 - x) * (1 - x);
}

export const controls = {
  a: false,
  d: false,
  w: false,
  s: false,
  r: false,
  shift: false,
  left: false,
  right: false,
  up: false,
  down: false,
};

export function resetControls() {
  for (const key in controls) {
    controls[key] = false;
  }
}

export function toggleTurbo() {
  controls.shift = !controls.shift;
}

const touchSensitiveHeight = window.innerHeight * 0.9; // 0.9 Adjust this value based on your preference

function handleKeyDown(e) {
  const key = e.key.toLowerCase();

  if (key === "arrowleft") {
    controls.left = true;
  } else if (key === "arrowright") {
    controls.right = true;
  } else if (key === "arrowup") {
    controls.up = true;
  } else if (key === "arrowdown") {
    controls.down = true;
  } else {
    controls[key] = true;
  }
}

function handleKeyUp(e) {
  const key = e.key.toLowerCase();

  if (key === "arrowleft") {
    controls.left = false;
  } else if (key === "arrowright") {
    controls.right = false;
  } else if (key === "arrowup") {
    controls.up = false;
  } else if (key === "arrowdown") {
    controls.down = false;
  } else {
    controls[key] = false;
  }
}


//  modification, verticalLimit represents the top 90% of the screen height, and horizontalLimit represents the center of the screen horizontally. 

function handleTouchStart(e) {
  e.preventDefault();

  const touchY = e.touches[0].clientY;
  const touchX = e.touches[0].clientX;

  const verticalLimit = window.innerHeight * 0.9;
  const horizontalLimit = window.innerWidth / 2;

  if (touchY < verticalLimit) {
    if (touchX < horizontalLimit) {
      controls["a"] = true;
    } else {
      controls["d"] = true;
    }

    if (touchY < window.innerHeight / 2) {
      controls["w"] = true;
    } else {
      controls["s"] = true;
    }
  }
}


function handleTouchEnd(e) {
  e.preventDefault();
  resetControls();
}

window.addEventListener("keydown", handleKeyDown);
window.addEventListener("keyup", handleKeyUp);
window.addEventListener("touchstart", handleTouchStart, { passive: false });
window.addEventListener("touchend", handleTouchEnd, { passive: false });

let maxVelocity = 0.04;
let jawVelocity = 0;
let pitchVelocity = 0;
let planeSpeed = 0.006;
export let turbo = 0;

export function updatePlaneAxis(x, y, z, planePosition, camera) {
  jawVelocity *= 0.95;
  pitchVelocity *= 0.95;

  if (Math.abs(jawVelocity) > maxVelocity) jawVelocity = Math.sign(jawVelocity) * maxVelocity;

  if (Math.abs(pitchVelocity) > maxVelocity) pitchVelocity = Math.sign(pitchVelocity) * maxVelocity;

  if (controls["a"] || controls.left) {
    jawVelocity += 0.0025;
  }

  if (controls["d"] || controls.right) {
    jawVelocity -= 0.0025;
  }

  if (controls["w"] || controls.up) {
    pitchVelocity -= 0.0025;
  }

  if (controls["s"] || controls.down) {
    pitchVelocity += 0.0025;
  }

  if (controls["r"]) {
    jawVelocity = 0;
    pitchVelocity = 0;
    turbo = 0;
    x.set(1, 0, 0);
    y.set(0, 1, 0);
    z.set(0, 0, 1);
    planePosition.set(0, 3, 7);
  }

  x.applyAxisAngle(z, jawVelocity);
  y.applyAxisAngle(z, jawVelocity);

  y.applyAxisAngle(x, pitchVelocity);
  z.applyAxisAngle(x, pitchVelocity);

  x.normalize();
  y.normalize();
  z.normalize();

  if (controls.shift) {
    turbo += 0.025;
  } else {
    turbo *= 0.95;
  }
  turbo = Math.min(Math.max(turbo, 0), 1);

  let turboSpeed = easeOutQuad(turbo) * 0.02;

  camera.fov = 45 + turboSpeed * 900;
  camera.updateProjectionMatrix();

  planePosition.add(z.clone().multiplyScalar(-planeSpeed - turboSpeed));
}